import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function BalanceOutStandingReport() {
  return <ReportForm reportAPI={ ReportAPI.BALANCE_OUTSTANDING } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/BalanceOutstandingReport.js